import { AxiosError } from 'axios';

import {
  THROTTLE_BACKOFF_DELAYS_MS,
  THROTTLE_STATUS_CODE,
} from './useFreeCollectThrottle.consts';
import {
  EFreeCollectOutcome,
  FreeCollectResult,
} from './useFreeCollectThrottle.types';

const wait = (delayMs: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, delayMs));

export const collected = <T>(response: T): FreeCollectResult<T> => ({
  outcome: EFreeCollectOutcome.COLLECTED,
  response,
});

export const isThrottled = (error: unknown): boolean =>
  (error as AxiosError)?.response?.status === THROTTLE_STATUS_CODE;

export const collectWithBackoff = async <T>(
  performCollect: () => Promise<T>,
  delaysMs: number[] = THROTTLE_BACKOFF_DELAYS_MS,
): Promise<T> => {
  try {
    return await performCollect();
  } catch (error) {
    if (!isThrottled(error) || delaysMs.length === 0) throw error;
    await wait(delaysMs[0]);
    return collectWithBackoff(performCollect, delaysMs.slice(1));
  }
};
